import { GlobalConfigVo, SysDictItem, SysMenuVo } from 'typings/openapi';
import { OptionType } from '../types';
import { PurchaseMode } from './data';

export type Menu = SysMenuVo;

export interface Option {
  label: string;
  value: string | number;
}

/**
 * 导出字段的类型
 */
export enum ExportFiledType {
  /** 商品 */
  PRODUCT = '1',
  /** 需方 */
  PURCHASE = '2',
  /** 供方 */
  SUPPLIER = '3',
  /** 质检报告 */
  QUALITY_INSPECTION_REPORT = '4',
  /** 采购单 */
  PURCHASE_ORDER = '5',
  /** 供方利润核算-按明细（detailGroup，模板id：152） */
  SUPPLY_PROFIT_ACCOUNTING_DETAIL_GROUP = '152',
  /** 供方利润核算-按单据（documentsGroup，模板id：153） */
  SUPPLY_PROFIT_ACCOUNTING_DOCUMENTS_GROUP = '153',
  /** 供方利润核算-按商品（productGroup，模板id：154） */
  SUPPLY_PROFIT_ACCOUNTING_PRODUCT_GROUP = '154',
  /** 应收汇总 */
  RECEIVABLE_SUMMARY = '6',
  /** 应付汇总 */
  PAYABLE_SUMMARY = '7',
  /** 计划到货明细 */
  PLAN_DELIVERY_INFO = '8',
  /** 采购需求汇总 */
  PURCHASE_REQUIRE_SUMMARY = '9',
  /** 供方采购汇总商品 */
  SUPPLY_PROCUREMENT_SUMMARY = '10',
  /** 需方采购汇总商品 */
  PURCHASE_PROCUREMENT_SUMMARY = '11',
  /** 监管方采购汇商品 */
  MANAGE_PROCUREMENT_SUMMARY = '12',
  /** 供方采购汇总需方 */
  SUPPLY_PROCUREMENT_DEMAND_SUMMARY = '13',
  /** 监管方采购汇总需方 */
  PURCHASE_PROCUREMENT_DEMAND_SUMMARY = '14',
  /** 需方采购汇总供方 */
  SUPPLY_PROCUREMENT_SUPPLY_SUMMARY = '15',
  /** 监管方采购汇总供方 */
  PURCHASE_PROCUREMENT_SUPPLY_SUMMARY = '16',
  /** 需方申购商品明细 */
  PURCHASE_APPLY_GOODS_DETAIL = '17',
  /** 监管方申购需求汇总 --- 按商品 */
  MANAGE_APPLY_PURCHASE_SUMMARY = '18',
  /** 监管方导出申购单 */
  MANAGE_APPLY_PURCHASE = '19',
  /** 需方导出申购单 */
  PURCHASE_APPLY_PURCHASE = '20',
  /** 监管方/供方采购合同的批量导出 */
  MANAGE_SUPPLY_PURCHASE_CONTRACT = '21',
  /** 供方商品 */
  SupplyCommodity = '24',
  /** 组合商品 */
  ComposeProduct = '22',
  /** 需方菜谱管理 */
  PurchaserCookbook = '25',
  /** 监管方菜谱管理 */
  ManageCookbook = '26',
  COMPOSE_PRODUCT = '22',
  /** 菜谱汇总 */
  COOKBOOK_SUMMARY = '23',
  /** 账户管理 */
  ACCOUNT_MANAGE = '27',
  /** 账户流水管理 */
  ACCOUNT_TURNOVER = '30',
  /** 库存台账列表导出 */
  INVENTORY_STOCK = '31',
  /** 供方库存台账列表导出 */
  SUPPLY_INVENTORY_STOCK = '164',
  /** 实时库存列表导出 */
  INVENTORY_REALTIME = '32',
  /** 供方实时库存列表导出 */
  SUPPLY_INVENTORY_REALTIME = '171',
  /** 价格监控 */
  MANAGE_PRICE_MONITOR = '33',
  /** 需方价格监控 */
  PURCHASE_PRICE_MONITOR = '40',
  /** 供方价格监控 */
  SUPPLY_PRICE_MONITOR = '39',
  /** 入库单 */
  INBOUND_ORDER = '28',
  /** 出库单 */
  OUTBOUND_ORDER = '29',
  /** 申领单 */
  REQUISITION_ORDER = '46',
  /** 供方申领单导出 */
  SUPPLY_REQUISITION_ORDER = '169',
  /** 供方｜监管方支付流水导出 */
  PAYMENT_STATEMENT = '34',
  /** 需方支付流水导出 */
  PURCHASE_PAYMENT_STATEMENT = '41',
  /** 监管方对账单导出 */
  MANAGE_STATEMENT = '35',
  /** 需方对账单导出 */
  PURCHASE_STATEMENT = '36',
  /** 供方对账单导出 */
  SUPPLY_STATEMENT = '37',
  /** 供方绩效导出 */
  SupplierPerformance = '38',
  /** 需方｜监管方调度库存导出 */
  DISPATCH_INVENTORY = '45',
  /** 供方调度库存导出 */
  SUPPLIER_DISPATCH_INVENTORY = '167',
  /** AIO 营养成分导出 */
  AIO_NUTRIENT = '42',
  /** 盘点导出 */
  INVEBTORY_SHEET = '43',
  /** 物料转换 */
  MATERIAL_CONVERSION = '44',
  /** 供方物料转换导出 */
  SUPPLY_MATERIAL_CONVERSION = '170',
  /** 开票记录导出（监管方，供方） */
  MANAGE_SUPPLY_BILL_RECORD = '47',
  /** 开票记录导出（需方） */
  PURCHASE_BILL_RECORD = '48',
  /** 补货记录 */
  REPLENISH_RULES = '51',
  /** 收支记录导出 */
  INCOME_EXPENSE_RECORD = '49',
  /** 效期预警 */
  VALIDITY_WARNING = '52',
  /** 库存预警 */
  INWENTORY_WARNING = '53',
  /** 周转筐统计 */
  TURN_OVER_BASKET_STATISTICS = '54',
  /** 限价管理 */
  LIMIT_TIME = '55',
  /** 报餐汇总 */
  MEAL_SUMMARY = '56',
  /** 套餐管理 */
  PACKAGE_MANAGE = '57',
  /** 报餐记录 */
  MEAL_RECORD = '58',
  /** 套餐需求汇总 */
  PACKAGE_DEMAND_SUMMARY = '59',
  /** 监管方财务汇总表-按日期 */
  MANAGE_FINANCIAL_SUMMARY = '60',
  /** 监管方财务汇总表-按月 */
  MANAGE_FINANCIAL_MONTH_SUMMARY = '61',
  /** 供方财务汇总表-按日期 */
  SUPPLY_FINANCIAL_SUMMARY = '177',
  /** 供方财务汇总表-按月份 */
  SUPPLY_FINANCIAL_MONTH_SUMMARY = '178',
  /** 需方财务汇总表-按日期 */
  PURCHASE_FINANCIAL_SUMMARY = '50',
  /** 需方财务汇总表-按月份 */
  PURCHASE_FINANCIAL_MONTH_SUMMARY = '179',
  /** 统一定价 */
  UNIFORM_PRICE = '62',
  /** 商品税率 */
  TAX_RATE = '63',
  /** 就餐 */
  DINE_PERSONNAL = '65',
  /** 滞销品 */
  DEAD_STOCK = '64',
  /** 缴费单 */
  PAYMENT_RECEIPT = '67',
  /** 缴费记录 */
  PAYMENT_RECORDS = '66',
  /** 就餐人员 */
  ACCOMPANY_SUMMARY = '68',
  /** 班级 */
  CLASS_SUMMARY = '69',
  /** 员工 */
  EMPLOYEE_EXPORT = '70',
  /** 监管方缴费记录 */
  MANAGE_PAYMENT_RECORDS = '71',
  /** 需方就餐日历 */
  PURCHASER_DINING_CALENDAR = '72',
  /** 监管方就餐日历 */
  MANAGE_DINING_CALENDAR = '73',
  /** 监管方采购需求汇总-按商品 */
  MANAGE_PURCHASE_SUMMARY_PRODUCT = '74',
  /** 监管方采购需求汇总-按需方 */
  MANAGE_PURCHASE_SUMMARY_DEMAND = '75',
  /** 监管方采购需求汇总-按供方 */
  MANAGE_PURCHASE_SUMMARY_SUPPLIER = '76',
  /** 售后 */
  AFTER_SAFES = '77',
  /** 监管方自用菜谱管理 */
  ManageSelfCookbook = '78',
  /** 供方采购需求汇总-按需方 */
  SUPPLY_PURCHASE_SUMMARY_DEMAND = '79',
  /** 供方采购需求汇总-按食堂 */
  SUPPLY_PURCHASE_SUMMARY_DINING = '80',
  /** 需方画像 */
  PURCHASER_PORTRAIT = '81',
  /** 监管方采购需求汇总-按食堂 */
  MANAGE_PURCHASE_SUMMARY_DINING = '82',
  /** 食安统计表 */
  FOOD_SAFETY_REPORT = '83',
  /** 采购商品备注 */
  PURCHASE_SKU_REMARK = '84',
  /** 需方采购明细表 */
  PURCHASE_DETAIL_REPORT = '85',
  /** 司机绩效 */
  DRIVER_PERFORMANCE = '86',
  /** 数据仓库监管方采购汇总按商品 */
  MANAGE_PROCUREMENT_SUMMARY_BI = '88',
  /** 数据仓库监管方采购汇总按需方 */
  MANAGE_PROCUREMENT_DEMAND_SUMMARY_BI = '89',
  /** 数据仓库监管方采购汇总按供方 */
  MANAGE_PROCUREMENT_SUPPLY_SUMMARY_BI = '90',
  /** 数据仓库监管方财务汇总按日 */
  MANAGE_FINANCIAL_DATE_SUMMARY_BI = '99',
  /** 数据仓库监管方财务汇总按月*/
  MANAGE_FINANCIAL_MONTH_SUMMARY_BI = '100',
  /** 数据仓库需方采购汇总按商品 */
  PURCHASE_PROCUREMENT_SUMMARY_BI = '93',
  /** 数据仓库需方采购汇总按供方 */
  PURCHASE_PROCUREMENT_SUPPLY_SUMMARY_BI = '94',
  /** 数据仓库供方采购汇总按商品 */
  SUPPLY_PROCUREMENT_SUMMARY_BI = '91',
  /** 数据仓库供方采购汇总按需方 */
  SUPPLY_PROCUREMENT_DEMAND_SUMMARY_BI = '92',
  /** 按天统计收支汇总（财务汇总报表）-导出实现  --- 需方 模板id 95 */
  PURCHASE_FINANCIAL_DATE_SUMMARY_BI = '95',
  /** 按月统计收支汇总（财务汇总报表）-导出实现  --- 需方 模板id 96 */
  PURCHASE_FINANCIAL_MONTH_SUMMARY_BI = '96',
  /** 按天统计收支汇总（财务汇总报表）-导出实现  --- 供方 模板id 97 */
  SUPPLY_FINANCIAL_DATE_SUMMARY_BI = '97',
  /** 按月统计收支汇总（财务汇总报表）-导出实现  --- 供方 模板id 98 */
  SUPPLY_FINANCIAL_MONTH_SUMMARY_BI = '98',
  /** 导出食安统计 --- 模板id  = 87 */
  MANAGE_SAFE_SUMMARY_BI = '87',
  /** 需方库存明细表 */
  PURCHASE_STOCK_DETAIL_REPORT = '101',
  /** 库存损耗表-按单据 */
  INVENTORY_LOSS_ORDER = '184',
  /** 库存损耗表-按商品 */
  INVENTORY_LOSS_PRODUCT = '185',
  /** 配送损耗表-按单据导出 */
  DELIVERY_LOSS_ORDER = '186',
  /** 配送损耗表-按商品导出 */
  DELIVERY_LOSS_PRODUCT = '187',
  /** 供方采购明细表 */
  SUPPLY_DETAIL_REPORT = '102',
  /** 需方组汇总表 */
  PURCHASE_GROUP_SUMMARY = '103',
  /** 需方每日价格 */
  PURCHASE_DAILY_PRICE = '104',
  /** 计划到货明细 --- 按食堂 */
  PLAN_DELIVERY_DETAIL_DINING = '106',
  /** 计划到货明细 --- 按供方 */
  PLAN_DELIVERY_DETAIL_SUPPLIER = '107',
  /** 需方采购汇总表 --- 按食堂 */
  PURCHASER_PURCHASE_SUMMARY_DINING = '109',
  /** 供方采购汇总表 --- 按食堂 */
  SUPPLY_PROCUREMENT_SUMMARY_DINING = '110',
  /** 监管方采购汇总表 --- 按食堂 */
  MANAGE_PROCUREMENT_SUMMARY_DINING = '111',
  /** 监管方申购需求汇总-按需方 */
  MANAGE_APPLY_PURCHASE_SUMMARY_DEMAND = '112',
  /** 监管方申购需求汇总-按食堂 */
  MANAGE_APPLY_PURCHASE_SUMMARY_DINING = '108',
  /** 需方申购商品明细 -- 按食堂 */
  PURCHASER_APPLY_PURCHASE_SUMMARY_DINING = '105',
  /** 监管方 -- 对账汇总表 */
  MANAGE_STATEMENT_SUMMARY = '113',
  /** 监管方 -- 采购差异表 */
  MANAGE_PURCHASE_DIFF = '114',
  /** 监管方 -- 巡检汇总表按需方 */
  MANAGE_INSPECTION_DEMAND = '115',
  /** 监管方 -- 巡检汇总表按供方 */
  MANAGE_INSPECTION_SUPPLY = '116',
  /** 供方整改记录 */
  SUPPLY_MODIFY_RECORD = '117',
  /** 需方整改记录 */
  DEMAND_MODIFY_RECORD = '118',
  /** 监管平台 -- 按日期导出 --123 */
  MANAGE_PURCHASE_SUMMARY_EVAL_BY_DATE = '123',
  /** 监管平台 -- 按供方导出 --124 */
  MANAGE_PURCHASE_SUMMARY_EVAL_BY_SUPPLIER = '124',
  /** 监管平台 -- 按需方导出 --125 */
  MANAGE_PURCHASE_SUMMARY_EVAL_BY_DEMAND = '125',
  /** 需方平台 -- 按日期导出 --119 */
  PURCHASER_PURCHASE_SUMMARY_EVAL_BY_DATE = '119',
  /** 需方平台 -- 按供方导出 --120 */
  PURCHASER_PURCHASE_SUMMARY_EVAL_BY_SUPPLIER = '120',
  /** 供方平台 -- 按日期导出 --121 */
  SUPPLY_PURCHASE_SUMMARY_EVAL_BY_DATE = '121',
  /** 供方平台 -- 按需方导出 --122 */
  SUPPLY_PURCHASE_SUMMARY_EVAL_BY_DEMAND = '122',
  /** 监管方绩效评分表 */
  MANAGE_PERFORMANCE_SCORE = '126',
  /** 监管方售后差异表 */
  MANAGE_AFTER_SALE_DIFF = '131',
  /** 需方售后明细表 */
  PURCHASE_AFTER_SALE_DETAIL = '132',
  /** 供方售后明细表 */
  SUPPLY_AFTER_SALE_DETAIL = '133',
  /** 监管方对账明细表 --- 按商品 */
  MANAGE_STATEMENT_DETAIL_PRODUCT = '134',
  /** 监管方对账明细表 --- 按分类 */
  MANAGE_STATEMENT_DETAIL_CATEGORY = '135',
  /** 监管方对账明细表 --- 按单据 */
  MANAGE_STATEMENT_DETAIL_BILL = '136',
  /** 供方明细导出 -- 按商品 */
  SUPPLY_DETAIL_REPORT_PRODUCT = '137',
  /** 供方明细导出 -- 按分类 */
  SUPPLY_DETAIL_REPORT_CATEGORY = '138',
  /** 供方明细导出 -- 按单据 */
  SUPPLY_DETAIL_REPORT_BILL = '139',
  /** 需方明细导出 -- 按商品 */
  PURCHASER_DETAIL_REPORT_PRODUCT = '140',
  /** 需方明细导出 -- 按分类 */
  PURCHASER_DETAIL_REPORT_CATEGORY = '141',
  /** 需方明细导出 -- 按单据 */
  PURCHASER_DETAIL_REPORT_BILL = '142',
  /** 行车数据 --- 按单据 */
  DRIVE_DATA = '130',
  /** 平台对接需方同步配置 */
  PLATFORM_DOCKING_DEMAND_SYNC_CONFIG = '127',
  /** 平台对接供方同步配置 */
  PLATFORM_DOCKING_SUPPLIER_SYNC_CONFIG = '155',
  /** 平台对接监管商品同步配置 */
  PLATFORM_DOCKING_SUPERVISE_PRODUCT_SYNC_CONFIG = '156',
  /** 观麦需方同步配置 */
  GUANMAI_DEMAND_SYNC_CONFIG = '192',
  /** 观麦监管商品同步配置 */
  GUANMAI_SUPERVISE_PRODUCT_SYNC_CONFIG = '193',
  /** 观麦非监管商品同步配置 */
  GUANMAI_NON_SUPERVISE_PRODUCT_SYNC_CONFIG = '194',
  /** 行车报警 */
  VEHICLE_ALARM = '4444',
  /** 供方成本记录 */
  SUPPLY_COST_RECORD = '148',
  /** 委外任务列表-按明细 */
  OUTSOURCE_TASK_LIST_DETAIL = '149',
  /** 委外任务列表-按单据 */
  OUTSOURCE_TASK_LIST_BILL = '150',
  /** 委外任务列表-按商品 */
  OUTSOURCE_TASK_LIST_PRODUCT = '151',
  /** 委外收入列表（导出模板 id：159） */
  OUTSOURCE_INCOME_LIST = '159',
  /** 代分拣列表 */
  REPLACE_SORTING_LIST = '157',
  /** IO记录-监管方 */
  MANAGE_IO_RECORD = '144',
  /** IO记录-供方 */
  SUPPLY_IO_RECORD = '145',
  /** 行车报警-监管方 模板id 146 */
  MANAGE_VEHICLE_ALARM = '146',
  /** 行车报警-供方 模板id 147 */
  SUPPLY_VEHICLE_ALARM = '147',
  /** 收据 */
  RECEIPT = '158',
  /** 监管方-定价审查 */
  MANAGE_PRICE_REVIEW = '160',
  /** 需方定价审查 */
  PURCHASE_PRICE_REVIEW = '161',
  /** 监管方-商品验收审查 */
  MANAGE_PRODUCT_REVIEW = '162',
  /** 需方-商品验收审查 */
  PURCHASE_PRODUCT_REVIEW = '163',
  /** 供方货源 */
  SUPPLY_SOURCE_LIST = '166',
  /** 供方货源绩效 */
  SUPPLY_SOURCE_PERFORMANCE = '198',
  /** 供方补货单 */
  SUPPLY_REPLENISHMENT_ORDER = '168',
  /** 供方补货规则 */
  SUPPLY_REPLENISH_RULES = '165',
  /** 供方协议价 */
  SUPPLY_REPLENISHMENT_PRICE = '188',
  /** 供方补货进度 */
  SUPPLY_REPLENISHMENT_PROGRESS = '190',
  /** 供方补货成本 */
  SUPPLY_REPLENISHMENT_COST = '191',
  /** 供方补货退回单 */
  SUPPLY_REPLENISHMENT_RETURN = '202',
  /** 供方分拣任务 */
  SUPPLY_SORT_TASK_LIST = '189',
  /** 保质期记录 */
  SHELF_LIFE_RECORD = '172',
  /** 委外验收列表 */
  OUTSOURCE_ACCEPTANCE_LIST = '173',
  /** 保质期跟踪 */
  SHELF_LIFE_TRACK = '174',
  /** 监管方-财务合规审查 */
  MANAGE_FINANCIAL_COMPLIANCE_REVIEW = '175',
  /** 需方-财务合规审查 */
  PURCHASE_FINANCIAL_COMPLIANCE_REVIEW = '176',
  /** 销项核算 */
  OUTPUT_ACCOUNTING = '181',
  /** 进项核算 */
  INPUT_ACCOUNTING = '182',
  /** 投筐记录 */
  TURN_OVER_BASKET_DELIVERY = '180',
  /** 行情价汇聚（新发地） TODO: 模板id 待与后端确认 */
  XINFADI_PRICE = '183',
  /** 库位分配规则 */
  POSITION_RULE = '199',
  /** 监管方-资金记录 */
  MANAGE_FUND_RECORD_LIST = '196',
  /** 需方-资金记录 */
  PURCHASE_FUND_RECORD_LIST = '195',
  /** 记账凭证 */
  VOUCHER = '197',
  /** 报价单批量导出（三端共用，模板id：200） */
  QUOTATION = '200',
  /** 补货计划-选择补货商品批量/全量导出（模板id：201） */
  REPLENISHMENT_PLAN_PRODUCT = '201',
  /** 账套总账批量/全量导出（模板id：203） */
  FINANCE_ACCOUNT_LEDGER = '203',
  /** 会计总账批量/全量导出（模板id：204） */
  FINANCE_GENERAL_LEDGER = '204',
  /** 入口率统计（按日）批量/全量导出（模板id：205） */
  ENTRY_RATE_STATISTICS_BY_DAY = '205',
  /** 入口率统计（按月）批量/全量导出（模板id：206） */
  ENTRY_RATE_STATISTICS_BY_MONTH = '206',
  /** 监管方投诉建议批量/全量导出（模板id：207） */
  MANAGE_SUGGESTION_EXPORT = '207',
  /** 需方投诉建议批量/全量导出（模板id：208） */
  PURCHASER_SUGGESTION_EXPORT = '208',
}

/**
 * GlobalConfigVo 中 dictInfoMap 的生成类型是坏的（Map_List_SysDictItem_），
 * 此处基于 OpenAPI 类型仅修正该字段，并保留 purchaseMode 的枚举语义
 */
export type GetGlobalConfigResponse = Omit<GlobalConfigVo, 'dictInfoMap' | 'purchaseMode'> & {
  /** 全局选项的映射关系 */
  dictInfoMap: Record<OptionType, SysDictItem[]>;
  purchaseMode: PurchaseMode;
};

export interface GetExportFieldsRequest {
  /** 导出字段类型 */
  template: ExportFiledType;
}

export interface ExportFileByQueryRequest {
  /** 是否全选 */
  isAll?: boolean;
  /** 导出的类型 */
  type: ExportFiledType;
  /** 需要导出的数据的keys */
  keys?: (string | number | bigint)[];
  /** 需要导出的数据的字段名 */
  exportStr: string[];
  /** 过滤条件 */
  filter?: Record<string, any>;
}
